const SupportTemplate = `
    <div class="addsearch-searchresults">
        {{#if support-results/hits}}
            <div class="number-of-results">{{support-results/total_hits}} results</div>
        {{/if}}
        {{#each support-results/hits}}
        <div class="hit">
            <h3>
            <a href="{{url}}" data-analytics-click="{{id}}">{{title}}</a>
            </h3>
            <div class="highlight">
            {{{highlight}}}..
            </div>
            {{#gt categories.length 1}}
                <div class="category">
                    {{selectCategory ..}}
                </div>
            {{/gt}}
        </div>
        {{/each}}
    </div>
`

export default SupportTemplate;
